module.exports = __webpack_public_path__ + "img/criterionimg2.e8cc1e32.png";